import { BaseApi } from '@/modules/core/base.api';
import { Agency } from './agency';
import { User } from '@/modules/user/user';
import { PaginationResult } from '@shared/common/types';
import * as API from '@shared/common/api';

class AgencyApi extends BaseApi {
    public apiPath = 'agency';


    public async findAll(options: object & { page: number }): Promise<PaginationResult<Agency>>;
    public async findAll(options?: object): Promise<Agency[]>;
    public async findAll(options: object = {}): Promise<API.GetAgenciesResponse> {
        const response = await this.api.get<object[] | PaginationResult<object>>(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });

        let result: Agency[] | PaginationResult<Agency>;

        if (Array.isArray(response.data)) {
            result = response.data.map((agency: object) => this.createInstance(agency));
        } else {
            result = {
                ...response.data,
                items: response.data.items.map((agency) => this.createInstance(agency)),
            };
        }

        return result;
    }

    public async create(agency: any): Promise<API.CreateAgency> {
        const response = await this.api.post(this.baseUrlFor(), agency);
        return response.data;
    }

    public async update(agency: any): Promise<API.UpdateAgency> {
        const response = await this.api.put(this.baseUrlFor(agency.id), agency);
        return response.data;
    }

    public async get(id: string): Promise<API.GetAgency> {
        const response = await this.api.get(this.baseUrlFor(id));
        return this.createInstance(response.data);
    }

    public async remove(id: string): Promise<API.DeleteAgency> {
        return await this.api.delete(this.baseUrlFor(id));
    }

    public async isLabelAvailable(label: string): Promise<API.IsAgencyLabelAvailable> {
        const response =  await this.api.get(this.baseUrlFor('is_label_available'), {
            params: {
                label,
            },
        });

        return response.data;
    }

    public async isCodeAvailable(code: string): Promise<API.IsAgencyCodeAvailable> {
        const response =  await this.api.get(this.baseUrlFor('is_code_available'), {
            params: {
                code,
            },
        });

        return response.data;
    }

    public createInstance(agency: any): Agency {
        const instance = new Agency(agency);

        if (instance.createdBy) {
            instance.createdBy = new User(instance.createdBy);
        }

        if (instance.updatedBy) {
            instance.updatedBy = new User(instance.updatedBy);
        }

        return instance;
    }
}

export const agencyApi = new AgencyApi();
